__turbopack_context__.v({
  "wpforms-field": "wp-form391-module__D35TrG__wpforms-field",
  "wpforms-field-description": "wp-form391-module__D35TrG__wpforms-field-description",
  "wpforms-field-medium": "wp-form391-module__D35TrG__wpforms-field-medium",
});
